export function getStageMode() {
    let fromNode;
    try {
        fromNode = process.env.NEXT_PUBLIC_ENVIRONMENT;
    }
    catch {
        fromNode = undefined;
    }
    let fromVite;
    try {
        fromVite = import.meta.env.VITE_PUBLIC_ENVIRONMENT;
    }
    catch {
        fromVite = undefined;
    }
    const rawStage = fromNode ?? fromVite;
    switch ((rawStage ?? 'dev').toLowerCase()) {
        case 'prod':
        case 'production': {
            return 'prod';
        }
        case 'test': {
            return 'test';
        }
        case 'support': {
            return 'support';
        }
        default: {
            return 'dev';
        } // fallback for dev, staging, etc.
    }
}
